import React from "react";
import "./gameOverMenu.css";

const GameOverMenu = props => {
	function gameOverWinner() {
		switch (props.gameOver) {
			case "BLACK FAILED TO DEFEND ITS KING":
			case "BLACK RESIGN FROM THE GAME":
			case "BLACK CHECK MATED":
				return "WHITE WINS";

			case "WHITE FAILED TO DEFEND ITS KING":
			case "WHITE RESIGN FROM THE GAME":
			case "WHITE CHECK MATED":
				return "BLACK WINS";

			case "STALEMATE":
			case "PLAYERS AGREED TO DRAW":
				return "DRAW";
		}
	}
	return (
		<div className="game-over-menu">
			<div className={props.gameOver ? "game-over-visible" : "game-over-hidden"}>
				<div className="game-over-menu-container">
					<div className="game-over-title">
						<p className="game-over-winner">{gameOverWinner()}</p>
						<p className="game-over-cause">{props.gameOver}</p>
					</div>
					<input
						type="button"
						value="REMATCH"
						className="game-over-cause game-over-option"
						onClick={() => props.handleResetBoard()}
					/>

					<input
						type="button"
						value="MAIN MENU"
						className="game-over-cause game-over-option"
						onClick={() => (window.location = window.location.origin)}
					/>
				</div>
			</div>
		</div>
	);
};

export default GameOverMenu;
